<template>
	<div class="inline-block">
		<i v-if="ntf.options.type === $constant.NOTIFICATION.TYPE.REQUEST" :class="[!ntf.is_read ? `text-${'primary'}` : `text-${'dark'}`, 'nucleo h-6 w-6 mt-1 nucleo-file-paragraph']"> </i>
		<i v-else-if="ntf.options.type === $constant.NOTIFICATION.TYPE.DEVICE" :class="[!ntf.is_read ? `text-${'primary'}` : `text-${'dark'}`, 'nucleo h-6 w-6 mt-1 nucleo-server-2']"> </i>
		<i v-else-if="ntf.options.type === $constant.NOTIFICATION.TYPE.TODOLIST" :class="[!ntf.is_read ? `text-${'primary'}` : `text-${'dark'}`, 'nucleo h-6 w-6 mt-1 nucleo-archive-paper-2']"> </i>
		<i v-else-if="ntf.options.type === $constant.NOTIFICATION.TYPE.POST" :class="[!ntf.is_read ? `text-${'primary'}` : `text-${'dark'}`, 'nucleo h-6 w-6 mt-1 nucleo-billboard-2']"> </i>
		<i v-else :class="[!ntf.is_read ? `text-${'primary'}` : `text-${'dark'}`, 'nucleo nucleo-bell-2']"> </i>
	</div>
</template>

<script>
export default {
	name: "NotiIcon",
	props: {
		ntf: {}
	}
};
</script>
